<script setup lang="ts">
import { computed } from 'vue';
import { useGroupStore } from '@/stores/group';

const store = useGroupStore();
const group = computed(() => store.group);
</script>

<template>
  <div class="welcome">
    <p class="welcome__text">{{ $t('welcome') }} 👋</p>
    <img v-if="group?.logo_url" :src="group.logo_url" alt="group logo" class="welcome__group-logo" />
  </div>
</template>

<style lang="scss" scoped>
.welcome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 5rem;

  &__text {
    color: $black;
    font-weight: 600;
    font-size: $font-size-title;
  }

  &__group-logo {
    object-fit: contain;
    max-width: 30%;
    height: 85%;
  }

  @media only screen and (max-width: $mobile-width-value) {
    &__text {
      font-size: $font-size-title-mobile;
    }
  }
}
</style>
